import { gql } from "@apollo/client";

export const GET_MAIL = gql`
	query Mails($mailId: UUID!) {
		mails(where: { id: { eq: $mailId } }) {
			nodes {
				id
				fromMailAddress
				fromDisplay
				bccRecipients
				ccRecipients
				dateTimeStamp
				identifier
				body
				subject
				attachments {
					key
				}
				metaData {
					description {
						relatedEmailAddress
					}
				}
				logs {
					id
					dateTimeStamp
					status
				}
				mailSet {
					id
				}
				templateId
			}
		}
	}
`;
